<div class="login-page">
  <section class="login-card" aria-labelledby="login-titulo">
    <div class="login-brand">
      <img src="assets/img/logofede.png" alt="Federació de Les Fogueres de Sant Joan" width="96" height="96">
      <h1 id="login-titulo">Censo FFSJ</h1>
      <p>Federació de Les Fogueres de Sant Joan</p>
    </div>

    <form (ngSubmit)="showChangePasswordForm ? changePassword() : login()" novalidate>
      <h2 class="login-subtitle">{{ showChangePasswordForm ? 'Elige una contraseña nueva' : 'Acceso a consultas del censo' }}</h2>

      @if (errorGeneral && !showChangePasswordForm) {
        <div class="alert alert-danger" role="alert" data-testid="login-error">{{ errorGeneral }}</div>
      }

      <div class="mb-3">
        <label for="username" class="form-label">Usuario</label>
        <input type="text" id="username" class="form-control" autocomplete="username" autocapitalize="none" spellcheck="false"
          [formControl]="username" [class.is-invalid]="faltaUsuario" [attr.aria-invalid]="faltaUsuario"
          [attr.aria-describedby]="faltaUsuario ? 'username-error' : null" [readOnly]="showChangePasswordForm || loading">
        @if (faltaUsuario) { <div id="username-error" class="field-error" role="alert">Escribe tu usuario.</div> }
      </div>

      @if (showChangePasswordForm) {
        <div class="mb-3">
          <label for="password" class="form-label">Nueva contraseña</label>
          <input type="password" id="password" class="form-control" autocomplete="new-password" [formControl]="password"
            [class.is-invalid]="faltaPassword" [attr.aria-invalid]="faltaPassword" [attr.aria-describedby]="faltaPassword ? 'password-error' : null">
          @if (faltaPassword) { <div id="password-error" class="field-error" role="alert">Escribe la nueva contraseña.</div> }
        </div>
        <div class="mb-3">
          <label for="repeatPassword" class="form-label">Repite la nueva contraseña</label>
          <input type="password" id="repeatPassword" class="form-control" autocomplete="new-password" [formControl]="repeatPassword"
            [class.is-invalid]="faltaRepetir || noCoinciden" [attr.aria-invalid]="faltaRepetir || noCoinciden"
            [attr.aria-describedby]="faltaRepetir || noCoinciden ? 'repeat-error' : null">
          @if (faltaRepetir) { <div id="repeat-error" class="field-error" role="alert">Repite la nueva contraseña.</div> }
          @else if (noCoinciden) { <div id="repeat-error" class="field-error" role="alert">Las contraseñas no coinciden.</div> }
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-100" [disabled]="loading">{{ loading ? 'Actualizando…' : 'Actualizar contraseña' }}</button>
      } @else {
        <div class="mb-3">
          <label for="password" class="form-label">Contraseña</label>
          <div class="input-group">
            <input [type]="mostrarPassword ? 'text' : 'password'" id="password" class="form-control" autocomplete="current-password" [formControl]="password"
              [class.is-invalid]="faltaPassword" [attr.aria-invalid]="faltaPassword" [attr.aria-describedby]="faltaPassword ? 'password-error' : null" [readOnly]="loading">
            <button type="button" class="btn btn-outline-secondary" [attr.aria-pressed]="mostrarPassword" (click)="mostrarPassword = !mostrarPassword">
              <i class="bi" [class.bi-eye]="!mostrarPassword" [class.bi-eye-slash]="mostrarPassword" aria-hidden="true"></i>
              <span class="visually-hidden">{{ mostrarPassword ? 'Ocultar contraseña' : 'Mostrar contraseña' }}</span>
            </button>
          </div>
          @if (faltaPassword) { <div id="password-error" class="field-error" role="alert">Escribe tu contraseña.</div> }
        </div>
        <button type="submit" class="btn btn-primary btn-lg w-100" [disabled]="loading">
          @if (loading) { <span class="spinner-ring spinner-ring--sm" aria-hidden="true"></span> Entrando… } @else { Iniciar sesión }
        </button>
      }
    </form>
    <p class="login-foot">© Federació de Les Fogueres de Sant Joan</p>
  </section>
</div>
